import UtilsSchema from "@repoflow/schema/utils";
import TypesSchema from "@common/schema/types";

import FieldsSchema, {
  siteKey,
  orgId,
  siteId,
  postId,
  slug,
  title,
  abstract,
  image,
  tags,
  authorId,
  date,
  content,
  editedAt,
  publishedAt,
  publishedSlug,
  status,
  createdAt,
  updatedAt,
} from "./fields";

export default [
  ...UtilsSchema,
  ...TypesSchema,
  ...FieldsSchema,
  {
    id: "/Public/BlogPost",
    type: "object",
    properties: {
      siteKey,
      orgId,
      siteId,
      postId,
      slug,
      title,
      abstract,
      image,
      tags,
      authorId,
      date,
      content,
      status,
      editedAt,
      publishedAt,
      publishedSlug,
      createdAt,
      updatedAt,
    },
  },
  // Slug and title, nothing else: a post is created from its listing and then
  // written on its own screen, the way a page is. Both are required because
  // both are what Publish will refuse without.
  {
    id: "/Public/BlogPost/Create",
    type: "object",
    properties: {
      slug,
      title,
    },
    required: ["slug", "title"],
  },
  {
    id: "/Public/BlogPost/Update",
    type: "object",
    properties: {
      slug,
      title,
      abstract,
      image,
      tags,
      authorId,
      date,
      content,
    },
    required: ["slug", "title"],
  },
];
